module.exports = __webpack_public_path__ + "media/images/consultorio1-5300f0690f6d113a4b31ce35988c5392.svg";